import React from "react";
import { Card, CardContent, Typography, Box, Button, Stack, Chip, Divider } from "@mui/material";
import { BsCheckCircle, BsXCircle } from "react-icons/bs";
import img from "./Enterprise plan.png";

const PricingCards4 = ({ isYearly }) => {
  return (
    <Stack
      direction="column"
      spacing={4}
      alignItems="center"
      sx={{
        borderRadius: "10px",
      }}
    >
      {/* First Card */}
      <Card
        sx={{
          maxWidth: 290,
          margin: "auto",
          boxShadow: 3,
          borderRadius: 2,
          padding: 2,
          "&:hover": {
            backgroundColor: "#f1fffa",
          },
        }}
      >
        <CardContent>
          <Box textAlign="center" mb={1}>
            <Chip
              label="API Only Plan"
              sx={{
                backgroundColor: "#2cdc9e",
                borderRadius: 5,
                color: "white",
                fontWeight: "bold",
                fontSize: "16px",
                padding: "8px 10px",
                height: "32px",
                marginRight: "20%",
              }}
            />
          </Box>
          <Box textAlign="center" mb={3}>
            <Typography variant="h4" fontWeight="600" color="black">
              {isYearly ? "₹31790" : "₹2799"}
              <span style={{ fontSize: "16px", color: "#333" }}>{isYearly ? "/Yearly" : "/Month"}</span>
            </Typography>
          </Box>
          <Divider sx={{ my: 2 }} />

          {/* content */}
          <Box sx={{ mt: 2, mb: 1 }}>
            {[
              { label: "Unlimited Messages", status: true },
              { label: "No Contact Limits", status: true },
              { label: "3 Days Message history", status: false },
              { label: "No Access to Any Features", status: false },
            ].map((item, index) => (
              <React.Fragment key={index}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={1}
                >
                  <Typography sx={{ fontSize: "16px", color: "#333" }}>{item.label}</Typography>
                  {item.status ? (
                    <BsCheckCircle style={{ color: "#32cd84", fontSize: "16px" }} />
                  ) : (
                    <BsXCircle style={{ color: "red", fontSize: "16px" }} />
                  )}
                </Box>
                {index < 3 && <Divider sx={{ mb: 1 }} />}
              </React.Fragment>
            ))}
          </Box>
        </CardContent>
      </Card>

      {/* Second Card */}
      <Card
        sx={{
          maxWidth: 290,
          margin: "auto",
          boxShadow: 3,
          borderRadius: 2,
          padding: 2,
          "&:hover": {
            backgroundColor: "#f1fffa",
          },
          backgroundColor: "#e6f0fa",
          border: "2px solid #b4c5d6",
        }}
      >
        <CardContent>
          <Box textAlign="center" mb={1}>
            <Box
              sx={{
                backgroundColor: "#DCEEFF",
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                margin: "auto",
                marginBottom: "16px",
              }}
            >
              <img
                src={img}
                alt="Enterprise Icon"
                style={{
                  width: "40px",
                  height: "40px",
                  marginTop: "1px",
                }}
              />
            </Box>
          </Box>
          <Box textAlign="center" mb={1.5}>
            <Chip
              label="Enterprise Custom Plan"
              sx={{
                backgroundColor: "#497DF3",
                borderRadius: 5,
                color: "white",
                fontWeight: "bold",
                fontSize: "16px",
                padding: "10px 12px",
                height: "32px",
                marginRight: "20%",
              }}
            />
          </Box>
          <Typography
            variant="body1"
            sx={{
              textAlign: "left",
              color: "#666666",
              mb: 2,
              padding: "0 10px",
            }}
          >
            If you don’t find a suitable plan for you, don’t worry. We offer tailored plans according to your requirements, with enterprise-grade features
          </Typography>
          <Box textAlign="center">
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#6B48FF",
                color: "#ffffff",
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: "bold",
                width: "150px",
                padding: "2px",
                "&:hover": {
                  backgroundColor: "#5A3EBC",
                },
              }}
              endIcon={<span style={{ marginLeft: "5px" }}>→</span>}
            >
              Contact Us
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Stack>
  );
};

export default PricingCards4;




